import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"
import { AxiosResponse } from "axios"
import { CreateScrapRuleSchema } from "../schemas/createScrapRule.schema"
import { unFormatUnit } from "@/common/utils/unFormatters"

interface UseCreateScrapRuleProps {
  companyId?: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: any) => void
}

const useCreateScrapRule = ({ companyId, onSuccess, onError }: UseCreateScrapRuleProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['createScrapRule'],
    mutationFn: async (form: CreateScrapRuleSchema) => {
      const scrap_rule = {
        display_name: form.display_name,
        company_id: companyId,
        maximum_mileage_condition: form.has_mileage && form?.maximum_mileage_condition ? unFormatUnit(form.maximum_mileage_condition, 'Km') : undefined,
        maximum_usage_hours_condition: form.has_hours  && form?.maximum_usage_hours_condition ? unFormatUnit(form.maximum_usage_hours_condition, 'H') : undefined,
        maximum_usage_time_in_years_condition: form.has_years && form?.maximum_usage_time_in_years_condition ? unFormatUnit(form.maximum_usage_time_in_years_condition, '') : undefined,
        equipment_category_ids: form.equipment_category_ids ? form.equipment_category_ids.map((item) => item.value) : undefined,
        branch_ids: form.branch_ids ? form.branch_ids.map((item) => item.value) : undefined,
        manufacturer_ids: form.manufacturer_ids ? form.manufacturer_ids.map((item) => item.value) : undefined,
        equipment_model_ids: form.equipment_model_ids ? form.equipment_model_ids.map((item) => item.value) : undefined,
        equipment_ids: form.equipment_ids ? form.equipment_ids.map((item) => item.value) : undefined,
      }

      return privateAxios.post(`/maintenance/scrap_rules`, { scrap_rule })
    },
    onSuccess,
    onError,
  })
}

export default useCreateScrapRule

